import React, { useContext, useEffect, useState, useRef } from 'react';
import { LanguageContext } from '../../core/Contexts/LanguageContext';
import {
  loadGoogleTranslate,
  changeGoogleLanguage,
} from '../../core/services/translationService';

const LanguageSwitcher = () => {
  const { language, changeLanguage } = useContext(LanguageContext);
  const [isChanging, setIsChanging] = useState(false);
  const selectRef = useRef(null);
  const [isInitialized, setIsInitialized] = useState(false);

  // Load Google Translate and handle language changes
  useEffect(() => {
    if (!isInitialized) {
      loadGoogleTranslate();

      // Set initial language only if not already set
      const storedLang = localStorage.getItem('appLanguage');
      if (storedLang === 'ka') {
        const forceGeorgian = () => {
          const selectEl = document.querySelector('.goog-te-combo');
          if (selectEl) {
            selectEl.value = 'ka';
            const event = new Event('change', { bubbles: true });
            selectEl.dispatchEvent(event);
          }
        };

        // Try to force Georgian immediately
        forceGeorgian();
        const interval = setInterval(() => {
          forceGeorgian();
        }, 100);

        // Clear interval after 1 second
        setTimeout(() => {
          clearInterval(interval);
          setIsInitialized(true);
        }, 1000);
      } else {
        setIsInitialized(true);
      }
    }
  }, [isInitialized]);

  // Handle language changes after initialization
  useEffect(() => {
    if (isInitialized && language) {
      changeGoogleLanguage(language);
    }
  }, [language, isInitialized]);

  // Keep checking to ensure the dropdown labels are consistent
  useEffect(() => {
    const checkLabels = () => {
      if (selectRef.current) {
        const options = selectRef.current.options;
        if (options[0].text !== 'ქარ') options[0].text = 'ქარ';
        if (options[1].text !== 'ENG') options[1].text = 'ENG';
      }
    };

    // Check immediately and then periodically
    checkLabels();
    const interval = setInterval(checkLabels, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleLanguageChange = (e) => {
    const newLang = e.target.value;

    // Prevent rapid switching that can confuse Google Translate
    if (isChanging) return;

    setIsChanging(true);
    changeLanguage(newLang);
    changeGoogleLanguage(newLang);

    // Reset the changing flag after a short delay
    setTimeout(() => {
      setIsChanging(false);
    }, 300);
  };

  return (
    <div>
      <select
        ref={selectRef}
        value={language}
        onChange={handleLanguageChange}
        disabled={isChanging}
      >
        <option value='ka'>ქარ</option>
        <option value='en'>ENG</option>
      </select>
      {/* This is where the Google widget mounts, hidden via CSS */}
      <div id='google_translate_element'></div>
    </div>
  );
};

export default LanguageSwitcher;
